import { render, staticRenderFns } from "./SearchPageSj.vue?vue&type=template&id=10df37fe&scoped=true&"
import script from "./SearchPageSj.vue?vue&type=script&lang=js&"
export * from "./SearchPageSj.vue?vue&type=script&lang=js&"
import style0 from "./SearchPageSj.vue?vue&type=style&index=0&id=10df37fe&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10df37fe",
  null
  
)

export default component.exports